import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Paper, Typography, Slider, Checkbox, TextField, Button, CircularProgress} from "@material-ui/core";
import {CheckCircle, Help, RadioButtonUnchecked} from '@material-ui/icons';
import {createWriteStream} from "streamsaver";
import { makeStyles } from "@material-ui/core/styles";
import {INotificacion, IParcela, ISections, IZona} from "../../../types";
import DatePicker, {registerLocale} from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import es from 'date-fns/locale/es';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine} from "recharts";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import {userService} from "../../../services/UserService";
import {LatLngTuple} from "leaflet";
import {resolucion_tablet} from "../../../tools/resolucion";

registerLocale('es', es)


const config = require('../../../config.json');
const texts = require('../../../texts/visualizador.json');


interface IProps {
    setZonas(zonas: number): void
    notify(notification: INotificacion): void
    setZonificacion(zonificacion: boolean): void
    setZonificaciones(zonificaciones: IZona[]): void
    setLoadingZonificador(loading_zonificador: boolean): void
    setProduct(product: string): void
    setMenu(menu: boolean): void
    openNota(callback: string): void
    menu: boolean
    zonas: number
    histograma: Record<string, number>[]
    scale: Record<number, (number | string)[]>
    product: string
    parcela: IParcela
    zonificaciones: IZona[]
    loading_zonificador: boolean
    idioma: string
}

interface IState {
    recarga: boolean
    rangos: number[]
    logScale: boolean
    nombreCapa: string
    vertical: boolean
    cambiando: boolean
    text: Record<string, string>
}

class Zonificador extends React.Component<IProps, IState> {
    state: IState = {
        recarga: false,
        rangos: [],
        logScale: false,
        nombreCapa: '',
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        const min: number = this.props.histograma[0]['name']
        const max: number = this.props.histograma[this.props.histograma.length-1]['name']

        const zonas: Record<number, Record<string, number[]>> = {
            2: {
                "intervalos": [Math.round(100*min) + Math.round(100*(max-min)/2)]
            },
            3: {
                "intervalos": [
                    Math.round(100*min) + Math.round(100*(max-min)/3),
                    Math.round(100*min) + Math.round(200*(max-min)/3)
                ]
            },
            4: {
                "intervalos": [
                    Math.round(100*min) + Math.round(100*(max-min)/4),
                    Math.round(100*min) + Math.round(200*(max-min)/4),
                    Math.round(100*min) + Math.round(300*(max-min)/4)]
            },
            5: {
                "intervalos": [
                    Math.round(100*min) + Math.round(100*(max-min)/5),
                    Math.round(100*min) + Math.round(200*(max-min)/5),
                    Math.round(100*min) + Math.round(300*(max-min)/5),
                    Math.round(100*min) + Math.round(400*(max-min)/5)]
            }
        }
        this.setState({
            rangos: zonas[this.props.zonas]['intervalos'],
            recarga: true
        })
        setTimeout(() => this.setState({recarga: false}),100)
    }

    renderBar = (max:number, min:number) => {
        const intervalos = []
        intervalos.push(max*100)
        for (let i=1; i<this.state.rangos.length+1; i++) {
            intervalos.push(this.state.rangos[this.state.rangos.length-i])
        }
        intervalos.push(min*100)

        const anchuras: string[] = []
        const indices: number[] = []
        for (let i=0; i<intervalos.length-1; i++) {
            anchuras.push((Math.round(100*(intervalos[i] - intervalos[i+1])/(max - min))/100).toString()+'%')
            indices.push(i)
        }

        let colores: string[] = []

        if (anchuras.length === 2) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[0][0] as string
            ]
        }
        if (anchuras.length === 3) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[2][0] as string,
                this.props.scale[0][0] as string
            ]
        }
        if (anchuras.length === 4) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[3][0] as string,
                this.props.scale[1][0] as string,
                this.props.scale[0][0] as string
            ]
        }
        if (anchuras.length === 5) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[3][0] as string,
                this.props.scale[2][0] as string,
                this.props.scale[1][0] as string,
                this.props.scale[0][0] as string
            ]
        }
        return (
            indices.map(i =>
                <div
                    key={i}
                    style={{
                        width: anchuras[i],
                        height: 10,
                        backgroundColor: colores[i],
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: 'black',
                        borderTopRightRadius: i === 0? 6 : 0,
                        borderBottomRightRadius: i === 0? 6 : 0,
                        borderTopLeftRadius: i === anchuras.length-1? 6 : 0,
                        borderBottomLeftRadius: i === anchuras.length-1? 6 : 0
                    }}
                />
            )
        )
    }


    delay = (ms: number) => new Promise(res => setTimeout(res, ms));


    handleClick = () => {
        this.props.setLoadingZonificador(true)
        const rangos: number[] = []
        let colores: string[] = []
        for (const i of this.state.rangos) {
            rangos.push(i/100)
        }

        if (rangos.length + 1 === 2) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[0][0] as string
            ]
        }
        if (rangos.length + 1 === 3) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[2][0] as string,
                this.props.scale[0][0] as string
            ]
        }
        if (rangos.length + 1 === 4) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[3][0] as string,
                this.props.scale[1][0] as string,
                this.props.scale[0][0] as string
            ]
        }
        if (rangos.length + 1 === 5) {
            colores = [
                this.props.scale[4][0] as string,
                this.props.scale[3][0] as string,
                this.props.scale[2][0] as string,
                this.props.scale[1][0] as string,
                this.props.scale[0][0] as string
            ]
        }

        let fuente = ""
        const parcela = this.props.parcela.id
        const fecha = (this.props.product.split(',')[1]).split('/').reverse().join('_')
        let indice = ""
        const nombre = this.state.nombreCapa
        let resol = 2

        if (["Humedad"].includes(this.props.product.split(',')[2])) {
            fuente = 'Humedad'
            indice = 'humedad'
            resol = 2
        }
        if (["dsm"].includes(this.props.product.split(',')[2])) {
            fuente = 'DSM'
            indice = 'dsm'
            resol = 1
        }
        if (["clay"].includes(this.props.product.split(',')[2])) {
            fuente = 'Clay'
            indice = 'clay'
            resol = 1
        }
        if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(this.props.product.split(',')[2])) {
            fuente = this.props.product.split(',')[2]
            indice = 'ETc_24'
            if (this.props.product.split(',')[2] === "ETc_low") {
                resol = 2
            } else {
                resol = 1
            }
        }
        if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] === "lst") {
            fuente = 'landsat_8'
            indice = this.props.product.split(',')[2]
            resol = 2
        }
        if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] !== "lst") {
            fuente = 'sentinel_2a'
            indice = this.props.product.split(',')[2]
            resol = 2
        }
        if (this.props.product.split(',')[0]==="dron") {
            fuente = 'rpas'
            indice = this.props.product.split(',')[2]
            resol = 1
        }

        axios.post(
            config.url+'/zonificar',
            {
                fuente: fuente,
                parcela: parcela,
                fecha: fecha,
                indice: indice,
                nombre: nombre,
                rangos: rangos,
                colores: colores,
                resol: resol
            },
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(async () => {

                let esperar = true
                while (esperar) {
                    await this.delay(1000);
                    const url: string = config.url + `/zonificacion/completa?fuente=${fuente}&parcela=${parcela}&fecha=${fecha}&indice=${indice}&nombre=${nombre}`
                    axios.get(
                        url,
                        {
                            auth: {
                                username: `${userService.getUser()}`,
                                password: `${userService.getPass()}`
                            }
                        })
                        .then(async (res) => {
                            if (res.status === 200) {
                                esperar = false
                                const url_2: string = config.url + `/get/zona?fuente=${fuente}&parcela=${parcela}&fecha=${fecha}&indice=${indice}&nombre=${nombre}`
                                axios.get(
                                    url_2,
                                    {
                                        auth: {
                                            username: `${userService.getUser()}`,
                                            password: `${userService.getPass()}`
                                        }
                                    })
                                    .then((res_2) => {

                                        const zonificaciones = []
                                        zonificaciones.push(res_2.data as IZona)
                                        for (const zona of this.props.zonificaciones) {
                                            if (zona.id === res_2.data.id) continue
                                            zonificaciones.push(zona)
                                        }
                                        this.props.setZonificaciones(zonificaciones)

                                        this.props.setLoadingZonificador(false)
                                        this.setState({nombreCapa: ''})
                                        this.props.notify({message: this.state.text["16"], variant: 'success'})
                                    })
                                    .catch(() => {
                                        this.props.notify({message: this.state.text["17"], variant: 'error'})
                                        this.props.setLoadingZonificador(false)
                                    })
                            } else if (res.status === 201) {
                                esperar = true
                                await this.delay(1000);
                            } else {
                                this.props.notify({message: this.state.text["17"], variant: 'error'})
                                this.props.setLoadingZonificador(false)
                                esperar = false
                            }
                        })
                        .catch(() => {
                            this.props.notify({message: this.state.text["17"], variant: 'error'})
                            this.props.setLoadingZonificador(false)
                            esperar = false
                        })
                    if (!esperar) return
                }

            })
            .catch(() => {
                this.props.notify({message: this.state.text["18"], variant: 'error'})
                this.props.setLoadingZonificador(false)
            })

    }


    render () {

        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false)


        const muiTheme = createTheme({
            overrides: {
                MuiSlider: {
                    thumb: {
                        color: "white",
                        width: 12,
                        height: 12,
                        borderStyle: "solid",
                        borderWidth:1,
                        borderColor: "black"
                    },
                    rail: {
                        color: "transparent"
                    },
                    track: {
                        color: "transparent"
                    },
                    valueLabel: {
                        top: 22,
                        fontSize: 10,
                        '& *': {
                            background: 'transparent',
                            color: '#000',
                        },
                    },
                }
            }
        });

        const helperTextStyles = makeStyles(theme => ({
            root: {
                margin: 4,
                color: "black"
            },
            error: {
                "&.MuiFormHelperText-root.Mui-error": {
                    color: "green"
                }
            }
        }));

        const min: number = this.props.histograma[0]['name']
        const max: number = this.props.histograma[this.props.histograma.length-1]['name']

        const zonas: Record<number, Record<string, number[]>> = {
            2: {
                "intervalos": [Math.round(100*min) + Math.round(100*(max-min)/2)]
            },
            3: {
                "intervalos": [
                    Math.round(100*min) + Math.round(100*(max-min)/3),
                    Math.round(100*min) + Math.round(200*(max-min)/3)
                ]
            },
            4: {
                "intervalos": [
                    Math.round(100*min) + Math.round(100*(max-min)/4),
                    Math.round(100*min) + Math.round(200*(max-min)/4),
                    Math.round(100*min) + Math.round(300*(max-min)/4)]
            },
            5: {
                "intervalos": [
                    Math.round(100*min) + Math.round(100*(max-min)/5),
                    Math.round(100*min) + Math.round(200*(max-min)/5),
                    Math.round(100*min) + Math.round(300*(max-min)/5),
                    Math.round(100*min) + Math.round(400*(max-min)/5)]
            }
        }

        const zonificaciones_creadas: string[] = []
        for (const i of Object.keys(this.props.zonificaciones)) {
            zonificaciones_creadas.push(this.props.zonificaciones[parseInt(i)]["id"].split(',')[4])
        }

        return (
            <div
                style={{
                    height: this.state.vertical?
                        resolucion_tablet()? "fit-content": "100%"
                        :
                        resolucion_tablet()? "fit-content": "100%"
                    ,
                    width: this.state.vertical?
                        resolucion_tablet()? '40%': "100%"
                        :
                        resolucion_tablet()? '30%': '40%'
                    ,
                    marginLeft: this.state.vertical?
                        this.props.menu?
                            resolucion_tablet()? '40%' : '0%'
                            :
                            '0%'
                        :
                        this.props.menu?
                            resolucion_tablet()? '30%' : '40%'
                            :
                            60
                    ,
                    marginRight: this.state.vertical?
                        resolucion_tablet()?
                            this.props.menu? '-80%' : 'calc(-40%)'
                            :
                            "-100%"
                        :
                        this.props.menu?
                            resolucion_tablet()? '-60%': '-80%'
                            :
                            resolucion_tablet()? 'calc(-30% - 60px)' : 'calc(-40% - 60px)'
                    ,
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    zIndex: 300,
                    borderTopRightRadius: 40,
                    borderBottomRightRadius: 40,
                    overflow: "auto",
                    direction: 'rtl'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: '90%',
                        height: '100%'
                    }}
                >
                    <Typography
                        style={{
                            marginTop: 40,
                            width: "100%",
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: 32,
                            color: '#4b484a',
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["19"]}
                    </Typography>

                    <Typography
                        style={{
                            marginTop: 20,
                            width: "100%",
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: 16,
                            color: '#4b484a',
                            fontFamily: "Poppins"
                        }}
                    >
                        {this.state.text["20"]}
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginRight: '10%'
                        }}
                    >
                        {[5, 4, 3, 2].map((element: number) =>
                            <Paper
                                key={element}
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: this.props.zonas === element? '#80ED99' : "white",
                                    width: 40,
                                    height: 40,
                                    borderRadius: 20,
                                    marginTop: 10,
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    this.setState({recarga: true, rangos: zonas[element]['intervalos']})
                                    this.props.setZonas(element)
                                    setTimeout(()=> this.setState({recarga: false}), 100)
                                }}
                            >
                                {element}
                            </Paper>
                        )}
                    </div>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '100%',
                            marginTop: 30,
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <Help
                            style={{
                                marginRight: 20,
                                marginLeft: 10,
                                cursor: "pointer"
                            }}
                            onClick={() => this.props.openNota(this.state.text["21"])}
                        />
                        <Typography
                            style={{
                                width: "100%",
                                textAlign: "center",
                                fontWeight: "bold",
                                fontSize: 16,
                                color: '#4b484a',
                                fontFamily: "Poppins"
                            }}
                        >
                            {this.state.text["26"]}
                        </Typography>
                    </div>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginRight: '10%',
                            width: '100%',
                            marginTop: 10,
                        }}
                    >
                        <ResponsiveContainer
                            width="100%"
                            height={150}
                        >
                            <AreaChart
                                data={this.props.histograma}
                                margin={{
                                    left: 20,
                                }}
                            >
                                <XAxis dataKey="name" angle={0} dy={5} fontSize={10}/>
                                <YAxis hide={true}/>
                                {!this.state.recarga &&
                                <Area
                                    type="monotone"
                                    dataKey={this.state.logScale? 'log' : 'y'}
                                    stroke="#80ED99"
                                    fill="#80ED99"
                                    strokeWidth={2}
                                    fillOpacity={0.3}
                                />
                                }
                            </AreaChart>
                        </ResponsiveContainer>


                        <div
                            style={{
                                marginTop: 10,
                                width: 'calc(100% - 20px)'
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: '100%',
                                    height: 12,
                                    zIndex: 100
                                }}
                            >
                                {!this.state.recarga && this.renderBar(max, min)}

                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    zIndex: 10,
                                    marginTop: -20
                                }}
                            >
                                <ThemeProvider theme={muiTheme}>
                                    {!this.state.recarga &&
                                    <Slider
                                        min={Math.round((min) * 100)}
                                        max={Math.round((max) * 100)}
                                        defaultValue={zonas[this.props.zonas]['intervalos']}
                                        value={this.state.rangos}
                                        valueLabelDisplay="on"
                                        scale={(x) => x / 100}
                                        onChange={(e, v) => {
                                            this.setState({rangos: v as number[]})
                                        }}
                                    />
                                    }
                                </ThemeProvider>
                            </div>
                        </div>

                        <TextField
                            style={{
                                width: '90%',
                                marginTop: 30,
                                direction: "ltr"
                            }}
                            id="standard-helperText"
                            value={this.state.nombreCapa}
                            label={this.state.text["29"]}
                            helperText={zonificaciones_creadas.includes(this.state.nombreCapa)?
                                this.state.text["28"]
                                :
                                null
                            }
                            error={zonificaciones_creadas.includes(this.state.nombreCapa)}
                            onChange={e => {
                                if (e.target.value.includes('/')) return
                                this.setState({nombreCapa: e.target.value})
                            }}
                        />

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '90%',
                                marginTop: 40,
                                marginBottom: 30
                            }}
                        >

                            <Button
                                disabled={this.state.nombreCapa.length === 0 || this.props.loading_zonificador}
                                color={"primary"}
                                variant={"contained"}
                                style={{
                                    textTransform: 'none',
                                    borderRadius: 10
                                }}
                                onClick={() => this.handleClick()}
                            >
                                {this.props.loading_zonificador?
                                    <CircularProgress
                                        style={{
                                            height: 20,
                                            width: 20,
                                            color: "#b43333"
                                        }}
                                    />
                                :
                                    <Typography
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: 16,
                                            color: '#4b484a',
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["23"]}
                                    </Typography>
                                }
                            </Button>
                            <Button
                                disabled={this.props.loading_zonificador}
                                style={{
                                    textTransform: 'none',
                                    marginRight: 20,
                                    borderRadius: 10
                                }}
                                onClick={() => this.props.setZonificacion(false)}
                            >
                                <Typography
                                    style={{
                                        fontSize: 16,
                                        color: '#4b484a',
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["24"]}
                                </Typography>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state: IStore) => ({
    menu: state.visualizador.menu,
    zonas: state.visualizador.zonas,
    histograma: state.visualizador.histograma,
    scale: state.visualizador.scale,
    product: state.visualizador.product,
    parcela: state.visualizador.parcela,
    zonificaciones: state.visualizador.zonificaciones,
    loading_zonificador: state.visualizador.loading_zonificador,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setZonas: (zonas: number) => dispatch({type: "set-visualizador-zonas", zonas}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setZonificacion: (zonificacion: boolean) => dispatch({type: "set-visualizador-zonificacion", zonificacion}),
    setZonificaciones: (zonificaciones: IZona[]) => dispatch({type: "set-visualizador-zonificaciones", zonificaciones}),
    setLoadingZonificador: (loading_zonificador: boolean) => dispatch({type: "set-loading-zonificador", loading_zonificador}),
    setProduct: (product: string) => dispatch({type: "set-visualizador-product", product}),
    setMenu: (menu: boolean) => dispatch({type: "set-visualizador-menu", menu}),
    openNota: (callback: string) => dispatch({type: "open-nota-dialog", callback})
});

export default connect(mapStateToProps, mapDispatchToProps)(Zonificador);